var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.376953 0H26.377C28.5861 0 30.377 1.79086 30.377 4V28C30.377 30.2091 28.5861 32 26.377 32H0.376953V0Z",
    fill: "#666DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.377 10.75H22.127V12.25H12.377V10.75ZM8.62695 10.375H10.877V12.625H8.62695V10.375ZM8.62695 14.875H10.877V17.125H8.62695V14.875ZM8.62695 19.375H10.877V21.625H8.62695V19.375ZM12.377 15.25H22.127V16.75H12.377V15.25ZM12.377 19.75H22.127V21.25H12.377V19.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/ListView.7448d729cc7005cd6f91eb4231149591.svg";
export { ForwardRef as ReactComponent };